// Stub — the full component lands in DEAP-4435 (#3327).
export function TopicNav(_props) {
    return null;
}
